var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D94F47",
    fillRule: "evenodd",
    d: "M22 2H2v20h20V2Zm-8.419 17.423c.753.014 1.506.027 2.253-.032l.008-.004c.73-.058 1.513-.291 1.488-1.262-.025-.95-.746-1.175-1.525-1.2-.617-.018-1.233-.02-1.85-.02-.527-.001-1.055-.002-1.584-.014-.071 0-.147.006-.224.012-.28.022-.573.046-.713-.258-.141-.306.058-.562.241-.798.033-.043.066-.085.096-.127.602-.818 1.32-1.53 2.039-2.243.192-.19.384-.38.574-.573 1.675-1.709 2.925-3.596 2.7-6.154-.071-.805-.467-1.284-1.2-1.3-2.15-.05-4.3-.05-6.446.016-.7.021-1.233.446-1.192 1.292.046.858.6 1.117 1.33 1.137.485.017.97.017 1.456.017.485 0 .97 0 1.456.017.095.003.2-.007.305-.016.355-.032.732-.067.887.357.162.444-.18.795-.473 1.096l-.07.071c-.33.345-.672.676-1.015 1.007-.454.438-.908.876-1.33 1.343-1.496 1.65-2.992 3.308-2.97 5.75.012 1.367.316 1.759 1.67 1.854.715.05 1.431.037 2.148.024.324-.005.649-.011.973-.011v.008c.322 0 .645.006.968.011Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/Zoho.6355d095e9ed1b60092da49eeb40d2ce.svg";
export { ForwardRef as ReactComponent };